
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29.333","height":"29.333","viewBox":"0 0 29.333 29.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.878 9.243c.379-4.4 2.64-6.2 7.59-6.2h.159c5.463 0 7.651 2.188 7.651 7.651v7.969c0 5.463-2.188 7.651-7.651 7.651h-.159c-4.913 0-7.174-1.772-7.578-6.1","fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('g',{attrs:{"opacity":".4","fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M2.444 14.667h15.742M15.461 10.573l4.094 4.094-4.094 4.095"}})])])
          )
        }
      }
    